var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuantity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3865 3.73186L13.3229 1.64857C12.9101 1.23584 12.3598 1 11.7702 1H3.20121C2.6116 1 2.0613 1.23584 1.64857 1.64857C1.23584 2.0613 1 2.6116 1 3.20121V17.4894C1 18.6883 1.98268 19.671 3.18156 19.671H13.8142C15.0131 19.671 15.9958 18.6883 15.9958 17.4894V5.26485C16.0351 4.69489 15.7992 4.14459 15.3865 3.73186ZM14.8165 4.30182C15.0131 4.49835 15.131 4.7342 15.19 4.9897H12.3598C12.1829 4.9897 12.0454 4.85212 12.0454 4.67524V1.84511C12.3009 1.90407 12.5367 2.02199 12.7332 2.21853L14.8165 4.30182ZM13.8535 18.8652H3.20121C2.43472 18.8652 1.82545 18.2559 1.82545 17.4894V3.18156C1.82545 2.80814 1.96303 2.47403 2.23818 2.19887C2.49368 1.94338 2.84745 1.78615 3.22086 1.78615L11.2592 1.8058V4.67524C11.2592 5.2845 11.7702 5.7955 12.3795 5.7955H15.2293V17.4698C15.2293 18.2363 14.6003 18.8652 13.8535 18.8652Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0847 11.7309H7.21056C6.99437 11.7309 6.79783 11.9078 6.79783 12.1436C6.79783 12.3598 6.97472 12.5564 7.21056 12.5564H12.1043C12.3205 12.5564 12.5171 12.3795 12.5171 12.1436C12.4974 11.9078 12.3205 11.7309 12.0847 11.7309Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0847 8.15393H7.21056C6.99437 8.15393 6.79783 8.33081 6.79783 8.56666C6.79783 8.78285 6.97472 8.97938 7.21056 8.97938H12.1043C12.3205 8.97938 12.5171 8.8025 12.5171 8.56666C12.4974 8.33081 12.3205 8.15393 12.0847 8.15393Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0847 15.2882H7.21056C6.99437 15.2882 6.79783 15.4651 6.79783 15.701C6.79783 15.9368 6.97472 16.1137 7.21056 16.1137H12.1043C12.3205 16.1137 12.5171 15.9368 12.5171 15.701C12.5171 15.4651 12.3205 15.2882 12.0847 15.2882Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40242 7.93774H4.97004C4.75385 7.93774 4.55731 8.11463 4.55731 8.35047V8.78285C4.55731 8.99904 4.7342 9.19558 4.97004 9.19558H5.40242C5.61861 9.19558 5.81515 9.0187 5.81515 8.78285V8.35047C5.7955 8.11463 5.61861 7.93774 5.40242 7.93774Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40242 11.5147H4.97004C4.75385 11.5147 4.55731 11.6916 4.55731 11.9274V12.3598C4.55731 12.576 4.7342 12.7725 4.97004 12.7725H5.40242C5.61861 12.7725 5.81515 12.5957 5.81515 12.3598V11.9078C5.7955 11.6916 5.61861 11.5147 5.40242 11.5147Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40242 15.072H4.97004C4.75385 15.072 4.55731 15.2489 4.55731 15.4847V15.9171C4.55731 16.1333 4.7342 16.3299 4.97004 16.3299H5.40242C5.61861 16.3299 5.81515 16.153 5.81515 15.9171V15.4847C5.7955 15.2489 5.61861 15.072 5.40242 15.072Z",
    fill: "#96A8BA",
    stroke: "#96A8BA",
    strokeWidth: 0.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantity);
export default __webpack_public_path__ + "static/media/quantity.554251f87eb8aa25916d5b33eaacb801.svg";
export { ForwardRef as ReactComponent };